import message from './message.vue'
import { getVmSingleton } from '@/utils/utils'

const messageCmp = {
  install (Vue) {
    const vm = getVmSingleton(message)()
    const obj = {}
    const queue = []
    let isPending = false

    const openVm = (msg, duration) => {
      isPending = true
      vm.open(msg, duration, obj.next.bind(obj))
    }
    const isTipsExit = target => queue.some(item => item.msg === target) || vm.message === target;

    ['err', 'success'].forEach(key => {
      obj[key] = function (msg, duration = 1500) {
        if (isTipsExit(msg)) return null
        if (queue.length || isPending) queue.push({ msg, duration })
        else openVm(msg, duration)
      }
    })

    obj.next = function () {
      isPending = false
      if (queue.length) {
        const m = queue.shift()
        openVm(m.msg, m.duration)
      }
    }

    Vue.prototype.$msg = obj
    window.$msg = obj
  }
}

export default messageCmp
